import { render, staticRenderFns } from "./CommonFooterDialog.vue?vue&type=template&id=cd3b1df8&scoped=true"
import script from "./CommonFooterDialog.vue?vue&type=script&lang=js"
export * from "./CommonFooterDialog.vue?vue&type=script&lang=js"
import style0 from "./CommonFooterDialog.vue?vue&type=style&index=0&id=cd3b1df8&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3b1df8",
  null
  
)

export default component.exports